import { Spinner } from '@kcftech/design-system';
import { CSSProperties, useEffect, useRef } from 'react';

export type ResultsLoadingIndicatorProps = Readonly<{
    className?: string;
    style?: CSSProperties;
}>;

export function ResultsLoadingIndicator({
    className,
    style,
}: ResultsLoadingIndicatorProps) {
    const ref = useRef<HTMLDivElement>(null);

    // Scroll loading indicator into view on mount
    useEffect(() => {
        ref.current?.scrollIntoView({ behavior: 'auto', block: 'nearest' });
    }, []);

    return (
        <div ref={ref} className={className} style={style}>
            <Spinner size="1x" />
        </div>
    );
}
